import React, { useEffect, useState } from 'react';

import './MUNIncludes.scss';

import ScrollButton from './../ScrollButton/ScrollButton';
function MUNIncludes() {
  const [mun, setMun] = useState([]);

  let price;
  let packagePrice;
  let applicationDate;

  useEffect(() => {
    fetch('http://localhost:8080/muns/mun')
      .then((res) => {
        if (res.status !== 200) {
          throw new Error('Failed to fetch mun.');
        }
        return res.json();
      })
      .then((resData) => {
        setMun(resData);

        // console.log('resData:', resData);
        // console.log(mun);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (mun.muns) {
    applicationDate = mun.muns[0].applicationDate;
    price = mun.muns[0].price;
    packagePrice = mun.muns[0].package;
  }

  return (
    <div className="MUNIncludes">
      <div className="MUNIncludes__price"> INR {price}</div>
      <div className="MUNIncludes__subtitle">Includes </div>
      <div className="MUNIncludes__features">
        <span className="MUNIncludes__features-item">Breakfast</span>
        <span className="MUNIncludes__features-line"></span>
        <span className="MUNIncludes__features-item">Lunch</span>
        <span className="MUNIncludes__features-line"></span>
        <span className="MUNIncludes__features-item">High Tea</span>
      </div>
      <div className="MUNIncludes__text">
        All meals along with the delegate kit will be provided at the venue of
        the event.
      </div>
      <div className="MUNIncludes__accomodation">
        <div className="MUNIncludes__accomodation-title">
          Accomodation Package available at INR {packagePrice}
        </div>
        <div className="MUNIncludes__accomodation-subtitle">
          For further details on accomodation:{' '}
        </div>
        <div className="MUNIncludes__accomodation-link-box">
          <a href="#" className="MUNIncludes__accomodation-link">
            Contact the organizer
          </a>
        </div>
      </div>
      <div className="MUNIncludes__application">
        <div className="MUNIncludes__application-title">
          E.B. Application Window
        </div>
        <div className="MUNIncludes__application-date">{applicationDate}</div>
        <p className="MUNIncludes__application-text">
          For further details on E.B.:
        </p>
        <a href="#" className="MUNIncludes__application-link">
          Contact the organizer
        </a>
      </div>

      <div className="MUNIncludes__btn-box">
        <ScrollButton text="Select Committee" arrow="down"></ScrollButton>
      </div>
    </div>
  );
}

export default MUNIncludes;
